import React, { Component } from "react";
import "./Checkbox.css";

export default class Checkbox extends Component {
  render() {
    return (
      <div className="checkbox-container">
        <div className="checkbox-container checkbox-coloured">
          <div className="checkbox">
            <label>
              <input type="checkbox" readOnly checked={this.props.checked}/>
              <span className="checkbox-material" onClick={this.props.clickFunc}>
                <span className="check" />
              </span>{" "}
            </label>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Checkbox.js